import React, { useState, useEffect } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import styled from 'styled-components';
import axios from 'axios';
import { API_SERVER_HOST } from '../Config';
import Banner from '../components/Banner';

const MemberListPage = () => {
  const [members, setMembers] = useState([]); // 회원 목록 저장을 위한 상태

  // 컴포넌트가 처음 렌더링될 때 회원 목록을 가져오는 함수
  useEffect(() => {
    const fetchMembers = async () => {
      const response = await axios.get(`${API_SERVER_HOST}/api/member/all`); // 백엔드 API 호출
      setMembers(response.data); // 가져온 데이터를 상태에 저장
    };

    fetchMembers(); // 회원 목록 가져오기
  }, []);

  // 자격증이 있을 경우, 해당 자격증의 URL 반환
  const checkCertificate = (member) => {
    const certificates = [];
    if (member.license1) certificates.push(`https://broj.s3.ap-northeast-2.amazonaws.com/${member.license1}`);
    if (member.license2) certificates.push(`https://broj.s3.ap-northeast-2.amazonaws.com/${member.license2}`);
    if (member.license3) certificates.push(`https://broj.s3.ap-northeast-2.amazonaws.com/${member.license3}`);
    return certificates.length > 0 ? certificates : null;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '0000-00-00';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <>
      <Banner title={'회원 목록'} />
      <BasicLayout>
        <Container>
          <Title>회원 목록</Title>
          <Table>
            <thead>
              <tr>
                <TableHeader> </TableHeader>
                <TableHeader>회원유형</TableHeader>
                <TableHeader>아이디</TableHeader>
                <TableHeader>이름</TableHeader>
                <TableHeader>지역</TableHeader>
                <TableHeader>번호</TableHeader>
                <TableHeader>email</TableHeader>
                <TableHeader>성별</TableHeader>
                <TableHeader>거주지</TableHeader>
                <TableHeader>생년월일</TableHeader>
                <TableHeader>가입날짜</TableHeader>
                <TableHeader>자격증</TableHeader>
              </tr>
            </thead>
            <tbody>
              {members.map((member, index) => (
                <TableRow key={member.id}>
                  <TableData>{index + 1}</TableData>
                  <TableData>{member.role}</TableData>
                  <TableData>{member.id}</TableData>
                  <TableData>{member.name}</TableData>
                  <TableData>{member.region}</TableData>
                  <TableData>{member.phone}</TableData>
                  <TableData>{member.email}</TableData>
                  <TableData>{member.gender}</TableData>
                  <TableData>
                    {member.address3} | {member.address1} | {member.address2}
                  </TableData>
                  <TableData>{formatDate(member.birthday)}</TableData>
                  <TableData>{formatDate(member.registerDTime)}</TableData>
                  <TableData>
                    {checkCertificate(member)
                      ? checkCertificate(member).map((certificate, idx) => (
                          <CertificateButton key={idx} onClick={() => window.open(certificate, '_blank')}>
                            자격증 보기 {idx + 1}
                          </CertificateButton>
                        ))
                      : '자격증 없음'}
                  </TableData>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </Container>
      </BasicLayout>
    </>
  );
};

const Container = styled.div`
  padding: 20px;
  background-color: #f9f9f9;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 18px;
  text-align: left;
`;

const TableHeader = styled.th`
  background-color: #eaeaea;
  padding: 12px;
  border: 1px solid #dddddd;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const TableData = styled.td`
  padding: 12px;
  border: 1px solid #dddddd;
`;

const CertificateButton = styled.button`
  padding: 5px 10px;
  background-color: #2ac49e;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 5px;

  &:hover {
    background-color: #38a169;
  }
`;

export default MemberListPage;
